import React from 'react';
import { Navigate } from 'react-router-dom';
import { Permission } from '../types/auth';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';

interface ProtectedRouteProps {
  element: React.ReactElement;
  isAuthenticated: boolean;
  requiredPermission?: Permission;
}

/**
 * Route guard that checks authentication and optional permission
 * If authenticated but lacks permission, shows a 403 Forbidden page
 * If not authenticated, redirects to home
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  isAuthenticated,
  requiredPermission,
}) => {
  const { t } = useTranslation();
  const auth = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Check permission if required
  if (requiredPermission && !auth.hasPermission(requiredPermission)) {
    return (
      <div className="forbidden-page" style={{ padding: '40px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '32px', marginBottom: '16px' }}>{t('components.protectedRoute.403AccessDenied')}</h1>
        <p style={{ color: '#6b7280', marginBottom: '24px' }}>
          {t('components.protectedRoute.youDoNotHavePermissionTo')}
        </p>
        <a href="/dashboard" style={{ color: '#3b82f6' }}>
          {t('components.protectedRoute.returnToDashboard')}
        </a>
      </div>
    );
  }

  return element;
};

export default ProtectedRoute;
